 import monitorOperadorHttpService from '../_service/monitorOperadorHttpService'

export const monitorOperadorMethods = {
  nomeENumeroDoOperador(agent) {
    let operador = ''
    let numero = ''
    let nomeDoOperadorReduzido = ''

    operador = this.nomeDoOperador(agent)
    numero = this.numeroDoOperador(agent)

    if (operador){
      if (operador.length > 12) {
          nomeDoOperadorReduzido = this.limitaCaracteresDoNomeDoOperador(operador)
          return `${nomeDoOperadorReduzido}\n${numero}`
      } else {
        return `${operador}\n${numero}`
      }
    } else {
      return ''
    }
  },

  nomeDoOperador(agent) {
    let operador = ''

    operador = agent.split('-')[0]

    if (operador){
      return `${operador}`
    } else {
      return ''
    }
  },

  numeroDoOperador(agent) {
    let numero = ''

    numero = agent.split('-')[1]

    if (numero){
      return `${numero}`
    } else {
      return ''
    }
  },

  // AÇÕES 

  //Pausa
  abreDialogPausa(operador) {
    this.dialogoPausa = true
    this.operadorSelecionado = operador
  },

  async pausaOuDespausaOperador(operador = null) {     
    if (!operador) {
      // PAUSA
        let agente = this.operadorSelecionado.agent.split('-')[1]
        this.dialogoPausa = false

        const data = { agente, action: 'pause', pause_id: this.dialogoPausaSelecionada, realizouEvento: 'Monitor' }
        await monitorOperadorHttpService.acoesOperador(data)
        this.dialogoPausaSelecionada = ''
    } else {
      // DESPAUSA
        let agente = operador.agent.split('-')[1]
        this.dialogoPausa = false

        const data = { agente, action: 'unpause', realizouEvento: 'Monitor' }
        await monitorOperadorHttpService.acoesOperador(data)
      }
  },

  //Remoção de Fila

  abreDialogRemoverFila(operador) {
    this.dialogoRemoverFila = true
    this.operadorSelecionado = operador
    this.getFilasOperador()
  },

  getFilasOperador() {
    this.filasOperador = []
    this.filas.forEach ((fila)=> {
      this.operadorSelecionado.arrayQueues.forEach ((filaOperadorId)=> {
        if (fila.value == filaOperadorId.queue) {
          this.filasOperador.push(fila)
        }
      })
    })
  },

  async removeFilaOperador() {
      let agente = this.operadorSelecionado.agent.split('-')[1]
      const data = { agente, action: 'removerAgenteEmFila', queue_id: this.dialogoRemoverFilaSelecionada, realizouEvento: 'Monitor' }
      await monitorOperadorHttpService.acoesOperador(data)
      this.dialogoRemoverFila = false
  },

  //Logout

  async logoutOperador(operador) {
  let alerta = window.confirm(`Deseja deslogar o operador "${operador.agent}"?`)

  if (alerta) {
    let agente = operador.agent.split('-')[1]
    const data = { agente, action: 'logout', realizouEvento: 'Monitor' }
    await monitorOperadorHttpService.acoesOperador(data)
  }
},

//Ouvir

abreDialogOuvirOperador(arrayChamadas, index) {
  console.log("ouvir")
  this.channelOuvido = arrayChamadas[index].channel
  this.dialogoOuvirOperador = true
},

async ouvirOperador() {
  this.dialogoOuvirOperador = false

  const data = { endpoint: this.ramalSelecionado, channelSpy: this.channelOuvido }
  await monitorOperadorHttpService.spyChannel(data)
},

  // Fim ações

  exibeOuOcultaTooltipDoNome(agent){
    let nomeDoOperador = ''

    nomeDoOperador = this.nomeDoOperador(agent)

    if (nomeDoOperador.length>12){
      return true
    } else {
      return false
    }
    },

  limitaCaracteresDoNomeDoOperador(nomeDoOperador){
    let nomeDoOperadorReduzido = ''
    nomeDoOperadorReduzido = nomeDoOperador.slice(0, 9)
    return `${nomeDoOperadorReduzido}...`
  },

  nomeDaPausa(pausa_id) {
    let pausa = this.pausas.find(pausa => pausa.value == pausa_id)

      if(pausa){
          return pausa.text
      } else {
        return ''
      }
  },

  exibeOuOcultaTooltipDaPausa(pausa_id){
    let nomeDaPausa = ''

    nomeDaPausa = this.nomeDaPausa(pausa_id)

    if (nomeDaPausa.length>12){
      return true
    } else {
      return false
    }
  },

  limitaCaracteresDoNomeDaPausa(nomeDaPausa){
    let nomeDaPausaReduzido = ''
    nomeDaPausaReduzido = nomeDaPausa.slice(0, 9)
    return `${nomeDaPausaReduzido}...`
  },

  indicadorDeLigacaoDeEntradaOuSaida(operador){
    if(typeof operador.channels !== 'undefined' && this.verificaLigacoes(operador.channels) > 0){
      if(operador.channels[operador.callIndex].io === 'outgoing'){
        return "mdi mdi-arrow-top-right"
      } else if (operador.channels[operador.callIndex].io === 'incoming'){
        return "mdi mdi-arrow-bottom-left"
      }
    }
  },
  
  numeroDoRamal(operador){
    return operador.deviceId
  },

  corDoStatus(operador) {
    if (operador.isNotRegistered) {
      return 'operadorOffline'
    }
    if (typeof operador.channels !== 'undefined' && operador.channels.length > 0 && operador.channels[operador.callIndex].state) {
      if (operador.channels[operador.callIndex].state === 'RING' || operador.channels[operador.callIndex].state === 'RINGING') {
        return 'operadorIniciandoOuRecebendoChamada'
      } else if (operador.channels[operador.callIndex].state === 'UP') {
        return 'operadorOcupado'
      }
    }

    if (operador.paused === '1') {
      return 'operadorEmPausa'
    }

    return 'operadorDisponivel'
  },

  verificaLigacoes(arrayChannels) {
    return arrayChannels.filter(channel => typeof channel.phoneNumber !== 'undefined').length
  },

  // getTextoDoStatus(call){ 
  //   if(typeof call.channels !== 'undefined' && this.verificaLigacoes(call.channels) > 0){
  //     return `${call.channels[call.callIndex].phoneNumber}\n${call.channels[call.callIndex].time}`
  //   } else {
  //       if(call.paused == '1'){ 
  //         let nomeDaPausa = this.nomeDaPausa(call.reason)
          
  //         if (nomeDaPausa.length>12){
  //           let nomeDaPausaReduzido = ''
  //           nomeDaPausaReduzido = this.limitaCaracteresDoNomeDaPausa(nomeDaPausa)
  //           return `${nomeDaPausaReduzido}\n${call.time}`
  //         } else {
  //             return `${nomeDaPausa}\n${call.time}`
  //         }
  //       }
  
  //     return `${call.time}`
  //   }
  // },

  numeroDaLigacao(call){ 
    if(typeof call.channels !== 'undefined' && this.verificaLigacoes(call.channels) > 0){
      // return `${call.channels[call.callIndex].phoneNumber}\n`
      return `${call.channels[call.callIndex].phoneNumber}`
    } 
  },

  pausa(call){ 
        let nomeDaPausa = this.nomeDaPausa(call.reason)
        
        if (nomeDaPausa.length>12){
          let nomeDaPausaReduzido = ''
          nomeDaPausaReduzido = this.limitaCaracteresDoNomeDaPausa(nomeDaPausa)
          // return `${nomeDaPausaReduzido}\n`
          return `${nomeDaPausaReduzido}`
        } else {
            // return `${nomeDaPausa}\n`
            return `${nomeDaPausa}`
        }
  },

  tempo(call){ 
    if(typeof call.channels !== 'undefined' && this.verificaLigacoes(call.channels) > 0){
      return `${call.channels[call.callIndex].time}`
    } else {
        if(call.paused == '1'){ 
              return `${call.time}`
          }
          return `${call.time}`
        }
  },

    // DIÁRIO
    diarioAtendidasEntrada(operador){
      let diarioAtendidasEntrada =''
      if(this.getCallsMonitorOperador.length != 0){
        if(this.getCallsMonitorOperador.Entrada.length != 0){
          if(this.getCallsMonitorOperador.Entrada.diario.length != 0){
            this.getCallsMonitorOperador.Entrada.diario.forEach(dadoDeEntradaDiario => {
              if (dadoDeEntradaDiario.operador === operador.agent) {
                diarioAtendidasEntrada = dadoDeEntradaDiario.atendidas
            }
            })
              if (diarioAtendidasEntrada == '') {
                diarioAtendidasEntrada = 0
              }
            return diarioAtendidasEntrada
          }else{
            return 0
          }
        }else{
          return 0
        }
      }
      return 0
    },

    diarioAtendidasSaida(operador){
      let diarioAtendidasSaida =''

      if(this.getCallsMonitorOperador.length != 0){
        if(this.getCallsMonitorOperador.Saida.length != 0){
          if(this.getCallsMonitorOperador.Saida.diario.length != 0){
            this.getCallsMonitorOperador.Saida.diario.forEach(dadoDeSaidaDiario => {
              if (dadoDeSaidaDiario.operador === operador.agent) {
                diarioAtendidasSaida = dadoDeSaidaDiario.atendidas
            }
            })
              if (diarioAtendidasSaida == ''){
                diarioAtendidasSaida = 0
              }
              return diarioAtendidasSaida
          }else{
            return 0
          }
        }else{
          return 0
        }
      }
      return 0
    },

    diarioAtendidasPorcentagem(operador){
      let diarioAtendidasPorcentagem = ''


      if(this.getCallsMonitorOperador.length != 0){
        if(this.getCallsMonitorOperador.Saida.length != 0){
          if(this.getCallsMonitorOperador.Saida.diariolength != 0){
            this.getCallsMonitorOperador.Saida.diario.forEach(dadoDeSaidaDiario => {
              if (dadoDeSaidaDiario.nivelServico.desempenho !== 'undefined') {
                if (dadoDeSaidaDiario.operador === operador.agent) {
                  diarioAtendidasPorcentagem = `| ${dadoDeSaidaDiario.nivelServico.desempenho}`
                } 
              }
              else {
                diarioAtendidasPorcentagem = '| 0%'
              }
              })
              if (diarioAtendidasPorcentagem == '') {
                diarioAtendidasPorcentagem = '| 0%'
              }
              
              return diarioAtendidasPorcentagem
          }else{
            return '| 0%'
          }
        }
        return '| 0%'
      }
      return '| 0%'

    },      
    
    diarioNaoAtendidasEntrada(operador){
      let diarioNaoAtendidasEntrada =''

      if(this.getCallsMonitorOperador.length != 0){
        if(this.getCallsMonitorOperador.Entrada.length != 0){
          if(this.getCallsMonitorOperador.Entrada.diario.length != 0){
            this.getCallsMonitorOperador.Entrada.diario.forEach(dadoDeEntradaDiario => {
              if (dadoDeEntradaDiario.operador === operador.agent) {
                diarioNaoAtendidasEntrada = dadoDeEntradaDiario.naoAtendidas
              }
            })
            if (diarioNaoAtendidasEntrada == '') {
                diarioNaoAtendidasEntrada = 0
            }
            return diarioNaoAtendidasEntrada
          }else{
            return 0
          }
        }else{
          return 0
        }
      }
      return 0

    },
    
    diarioNaoAtendidasSaida(operador){
      let diarioNaoAtendidasSaida =''
      if(this.getCallsMonitorOperador.length != 0){
        if(this.getCallsMonitorOperador.Saida.length != 0){
          if(this.getCallsMonitorOperador.Saida.diario.length != 0){
            this.getCallsMonitorOperador.Saida.diario.forEach(dadoDeSaidaDiario => {
              if (dadoDeSaidaDiario.operador === operador.agent) {
                diarioNaoAtendidasSaida = dadoDeSaidaDiario.naoAtendidas
              }
            })
            if (diarioNaoAtendidasSaida == '') {
                diarioNaoAtendidasSaida = 0
            }
            return diarioNaoAtendidasSaida
          }else{
            return 0
          }
        }else{
          return 0
        }
      }
      return 0

    },
    
    diarioTotalEntrada(operador){
      let diarioTotalEntrada =''
      if(this.getCallsMonitorOperador.length != 0){
        if(this.getCallsMonitorOperador.Entrada.length != 0){
          if(this.getCallsMonitorOperador.Entrada.diario.length != 0){          
            this.getCallsMonitorOperador.Entrada.diario.forEach(dadoDeEntradaDiario => {
              if (dadoDeEntradaDiario.operador === operador.agent) {
                diarioTotalEntrada = dadoDeEntradaDiario.totalChamadas
              }
            })
            if (diarioTotalEntrada == '') {
                diarioTotalEntrada = 0
            }
            return diarioTotalEntrada
          }else{
            return 0
          }
        }else{
          return 0
        }
      }
      return 0
    },

    diarioTotalSaida(operador){
      let diarioTotalSaida =''
      if(this.getCallsMonitorOperador.length != 0){
        if(this.getCallsMonitorOperador.Saida.length != 0){
          if(this.getCallsMonitorOperador.Saida.diario.length != 0){
            this.getCallsMonitorOperador.Saida.diario.forEach(dadoDeSaidaDiario => {
              if (dadoDeSaidaDiario.operador === operador.agent) {
                diarioTotalSaida = dadoDeSaidaDiario.totalChamadas
              }
            })
            if (diarioTotalSaida == '') {
                diarioTotalSaida = 0
            }
            return diarioTotalSaida
          }else{
            return 0
          }
        }else{
          return 0
        }
      }
      return 0
    },
    
    diarioTmc(operador){
      let diarioTmc = ''
      if(this.getCallsMonitorOperador.length != 0){
        if(this.getCallsMonitorOperador.Entrada.length != 0){
          if(this.getCallsMonitorOperador.Entrada.diario.length != 0){

            this.getCallsMonitorOperador.Entrada.diario.forEach(dadoDeEntradaDiario => {
              if (dadoDeEntradaDiario.operador === operador.agent) {
                diarioTmc = dadoDeEntradaDiario.mediaTempoDeChamada
              }
            })
            if (diarioTmc == '') {
                diarioTmc = '00:00:00'
            }
            return diarioTmc
          }else{
            return '00:00:00'
          }
        }else{
          return '00:00:00'
        }
      }
      return '00:00:00'
    },

    diarioTma(operador){
      let diarioTma = ''
      if(this.getCallsMonitorOperador.length != 0){
        if(this.getCallsMonitorOperador.Entrada.length != 0){
          if(this.getCallsMonitorOperador.Entrada.diario.length != 0){

            this.getCallsMonitorOperador.Entrada.diario.forEach(dadoDeEntradaDiario => {
              if (dadoDeEntradaDiario.operador === operador.agent) {
                diarioTma = dadoDeEntradaDiario.mediaTempoDeAtendimento
              }
            })
            if (diarioTma == '') {
                diarioTma = '00:00:00'
            }
            return diarioTma
          }else{
            return '00:00:00'
          }
        }else{
          return '00:00:00'
        }
      }
      return '00:00:00'
    },

    diarioTme(operador){
      let diarioTme = ''
      if(this.getCallsMonitorOperador.length != 0){
        if(this.getCallsMonitorOperador.Entrada.length != 0){
          if(this.getCallsMonitorOperador.Entrada.diario.length != 0){
            this.getCallsMonitorOperador.Entrada.diario.forEach(dadoDeEntradaDiario => {
              if (dadoDeEntradaDiario.operador === operador.agent) {
                diarioTme = dadoDeEntradaDiario.mediaEspera
              }
            })
            if (diarioTme == '') {
                diarioTme = '00:00:00'
            }
            return diarioTme
          }else{
            return '00:00:00'
          }
        }else{
          return '00:00:00'
        }
      }
      return '00:00:00'
    },

    // SEMANAL
    
   semanalAtendidasEntrada(operador){
      let semanalAtendidasEntrada =''
      if(this.getCallsMonitorOperador.length != 0){
        if(this.getCallsMonitorOperador.Entrada.length != 0){
          if(this.getCallsMonitorOperador.Entrada.semanal.length != 0){
            this.getCallsMonitorOperador.Entrada.semanal.forEach(dadoDeEntradaSemanal => {
              if (dadoDeEntradaSemanal.operador === operador.agent) {
                semanalAtendidasEntrada = dadoDeEntradaSemanal.atendidas
            }
            })
            if (semanalAtendidasEntrada == '') {
                semanalAtendidasEntrada = 0
              }
            return semanalAtendidasEntrada
          }else{
            return 0
          }
        }else{
          return 0
        }
      }
      return 0
    },

    semanalAtendidasSaida(operador){
      let semanalAtendidasSaida =''
      if(this.getCallsMonitorOperador.length != 0){
        if(this.getCallsMonitorOperador.Saida.length != 0){
          if(this.getCallsMonitorOperador.Saida.semanal.length != 0){
            this.getCallsMonitorOperador.Saida.semanal.forEach(dadoDeSaidaSemanal => {
              if (dadoDeSaidaSemanal.operador === operador.agent) {
                semanalAtendidasSaida = dadoDeSaidaSemanal.atendidas
            }
            })
              if (semanalAtendidasSaida == '') {
                semanalAtendidasSaida = 0
              }
            return semanalAtendidasSaida
          }else{
            return 0
          }
        }else{
          return 0
        }
      }
      return 0
    },

    semanalAtendidasPorcentagem(operador){
      let semanalAtendidasPorcentagem = ''
      if(this.getCallsMonitorOperador.length != 0){
        if(this.getCallsMonitorOperador.Saida.length != 0){
          if(this.getCallsMonitorOperador.Saida.semanal.length != 0){

            this.getCallsMonitorOperador.Saida.semanal.forEach(dadoDeSaidaSemanal => {
              if (dadoDeSaidaSemanal.nivelServico.desempenho !== 'undefined') {
                if (dadoDeSaidaSemanal.operador === operador.agent) {
                  semanalAtendidasPorcentagem = `| ${dadoDeSaidaSemanal.nivelServico.desempenho}`
                }
              } 
              else {
                semanalAtendidasPorcentagem = '| 0%'
              }
            })
              if (semanalAtendidasPorcentagem == '') {
                semanalAtendidasPorcentagem = '| 0%'
              } 
            return semanalAtendidasPorcentagem
          }else{
            return '| 0%'
          }
        }else{
          return '| 0%'
        }
      }
      return '| 0%'
    }, 
    
    
    semanalNaoAtendidasEntrada(operador){
      let semanalNaoAtendidasEntrada =''
      if(this.getCallsMonitorOperador.length != 0){
        if(this.getCallsMonitorOperador.Entrada.length != 0){
          if(this.getCallsMonitorOperador.Entrada.semanal.length != 0){

            this.getCallsMonitorOperador.Entrada.semanal.forEach(dadoDeEntradaSemanal => {
              if (dadoDeEntradaSemanal.operador === operador.agent) {
                semanalNaoAtendidasEntrada = dadoDeEntradaSemanal.naoAtendidas
              }
            })
            if (semanalNaoAtendidasEntrada == '') {
                semanalNaoAtendidasEntrada = 0
            }
            return semanalNaoAtendidasEntrada
          }else{
            return 0
          }
        }else{
          return 0
        }
      }
      return 0
    },
    
    semanalNaoAtendidasSaida(operador){
      let semanalNaoAtendidasSaida =''
      if(this.getCallsMonitorOperador.length != 0){
        if(this.getCallsMonitorOperador.Saida.length != 0){
          if(this.getCallsMonitorOperador.Saida.semanal.length != 0){

            this.getCallsMonitorOperador.Saida.semanal.forEach(dadoDeSaidaSemanal => {
              if (dadoDeSaidaSemanal.operador === operador.agent) {
                semanalNaoAtendidasSaida = dadoDeSaidaSemanal.naoAtendidas
              }
            })
            if (semanalNaoAtendidasSaida == '') {
                semanalNaoAtendidasSaida = 0
            }
            return semanalNaoAtendidasSaida
          }else{
            return 0
          }
        }else{
          return 0
        }
      }
      return 0
    }, 
    
    semanalTotalEntrada(operador){
      let semanalTotalEntrada =''
      if(this.getCallsMonitorOperador.length != 0){
        if(this.getCallsMonitorOperador.Entrada.length != 0){
          if(this.getCallsMonitorOperador.Entrada.semanal.length != 0){

            this.getCallsMonitorOperador.Entrada.semanal.forEach(dadoDeEntradaSemanal => {
              if (dadoDeEntradaSemanal.operador === operador.agent) {
                semanalTotalEntrada = dadoDeEntradaSemanal.totalChamadas
              } 
            })
            if (semanalTotalEntrada == '') {
                semanalTotalEntrada = 0
            }
            return semanalTotalEntrada
          }else{
            return 0
          }
        }else{
          return 0
        }
      }
      return 0
    },

    semanalTotalSaida(operador){
      let semanalTotalSaida =''
      if(this.getCallsMonitorOperador.length != 0){
        if(this.getCallsMonitorOperador.Saida.length != 0){
          if(this.getCallsMonitorOperador.Saida.semanal.length != 0){
            this.getCallsMonitorOperador.Saida.semanal.forEach(dadoDeSaidaSemanal => {
              if (dadoDeSaidaSemanal.operador === operador.agent) {
                semanalTotalSaida = dadoDeSaidaSemanal.totalChamadas
              }
            })
            if (semanalTotalSaida == '') {
                semanalTotalSaida = 0
            }
            return semanalTotalSaida
          }else{
            return 0
          }
        }else{
          return 0
        }
      }
      return 0 
    },
    
    semanalTmc(operador){
      let semanalTmc = ''
      if(this.getCallsMonitorOperador.length != 0){
        if(this.getCallsMonitorOperador.Entrada.length != 0){
          if(this.getCallsMonitorOperador.Entrada.semanal.length != 0){

            this.getCallsMonitorOperador.Entrada.semanal.forEach(dadoDeEntradaSemanal => {
              if (dadoDeEntradaSemanal.operador === operador.agent) {
                semanalTmc = dadoDeEntradaSemanal.mediaTempoDeChamada
              }
            })
            if (semanalTmc == '') {
                semanalTmc = '00:00:00'
            }
            return semanalTmc
          }else{
            return '00:00:00'
          }
        }else{
          return '00:00:00'
        }
      }
      return '00:00:00'
    },

    semanalTma(operador){
      let semanalTma = ''
      if(this.getCallsMonitorOperador.length != 0){
        if(this.getCallsMonitorOperador.Entrada.length != 0){
          if(this.getCallsMonitorOperador.Entrada.semanal.length != 0){

            this.getCallsMonitorOperador.Entrada.semanal.forEach(dadoDeEntradaSemanal => {
              if (dadoDeEntradaSemanal.operador === operador.agent) {
                semanalTma = dadoDeEntradaSemanal.mediaTempoDeAtendimento
              }
            })
            if (semanalTma == '') {
                semanalTma = '00:00:00'
            }
            return semanalTma
          }else{
            return '00:00:00'
          }
        }else{
          return '00:00:00'
        }
      }
      return '00:00:00'
    },

    semanalTme(operador){
      let semanalTme = ''
      if(this.getCallsMonitorOperador.length != 0){
        if(this.getCallsMonitorOperador.Entrada.length != 0){
          if(this.getCallsMonitorOperador.Entrada.semanal.length != 0){

            this.getCallsMonitorOperador.Entrada.semanal.forEach(dadoDeEntradaSemanal => {
              if (dadoDeEntradaSemanal.operador === operador.agent) {
                semanalTme = dadoDeEntradaSemanal.mediaEspera
              }
            })
            if (semanalTme == '') {
                semanalTme = '00:00:00'
            }
            return semanalTme
          }else{
            return '00:00:00'
          }
        }else{
          return '00:00:00'
        }
      }
      return '00:00:00'
    },

// MENSAL
    
   mensalAtendidasEntrada(operador){
      let mensalAtendidasEntrada =''
      if(this.getCallsMonitorOperador.length != 0){
        if(this.getCallsMonitorOperador.Entrada.length != 0){
          if(this.getCallsMonitorOperador.Entrada.mensal.length != 0){

            this.getCallsMonitorOperador.Entrada.mensal.forEach(dadoDeEntradaMensal => {
              if (dadoDeEntradaMensal.operador === operador.agent) {
                mensalAtendidasEntrada = dadoDeEntradaMensal.atendidas
            }
            })
            if (mensalAtendidasEntrada == '') {
                mensalAtendidasEntrada = 0
                }
            return mensalAtendidasEntrada
          }else{
            return 0
          }
        }else{
          return 0
        }
      }
      return 0
    },

    mensalAtendidasSaida(operador){
      let mensalAtendidasSaida =''
      if(this.getCallsMonitorOperador.length != 0){
        if(this.getCallsMonitorOperador.Saida.length != 0){
          if(this.getCallsMonitorOperador.Saida.mensal.length != 0){

            this.getCallsMonitorOperador.Saida.mensal.forEach(dadoDeSaidaMensal => {
              if (dadoDeSaidaMensal.operador === operador.agent) {
                mensalAtendidasSaida = dadoDeSaidaMensal.atendidas
            }
            })
            if (mensalAtendidasSaida == '') {
                mensalAtendidasSaida = 0
            }
            return mensalAtendidasSaida
          }else{
            return 0
          }
        }return 0
      }
      return 0 
    },

    mensalAtendidasPorcentagem(operador){
      let mensalAtendidasPorcentagem = ''
      if(this.getCallsMonitorOperador.length != 0){
        if(this.getCallsMonitorOperador.Saida.length != 0){
          if(this.getCallsMonitorOperador.Saida.mensal.length != 0){
      
            this.getCallsMonitorOperador.Saida.mensal.forEach(dadoDeSaidaMensal => {
              if (dadoDeSaidaMensal.nivelServico.desempenho !== 'undefined') {
              if (dadoDeSaidaMensal.operador === operador.agent) {
                mensalAtendidasPorcentagem = `| ${dadoDeSaidaMensal.nivelServico.desempenho}`
            } 
          }
          else {
            mensalAtendidasPorcentagem = '| 0%'
          }
            })
              if (mensalAtendidasPorcentagem == '') {
                mensalAtendidasPorcentagem = '| 0%'
              }
            return mensalAtendidasPorcentagem
          }else{
            return '| 0%'
          }
        }else{
          return '| 0%'
        }
      }
      return '| 0%'
    }, 
    
    
    mensalNaoAtendidasEntrada(operador){
      let mensalNaoAtendidasEntrada =''
      if(this.getCallsMonitorOperador.length != 0){
        if(this.getCallsMonitorOperador.Entrada.length != 0){
          if(this.getCallsMonitorOperador.Entrada.mensal.length != 0){

            this.getCallsMonitorOperador.Entrada.mensal.forEach(dadoDeEntradaMensal => {
              if (dadoDeEntradaMensal.operador === operador.agent) {
                mensalNaoAtendidasEntrada = dadoDeEntradaMensal.naoAtendidas
              }
            })
            if  (mensalNaoAtendidasEntrada == '') {
                mensalNaoAtendidasEntrada = 0
            }
            return mensalNaoAtendidasEntrada
          }else{
            return 0
          }
        }else{
          return 0
        }
      }
      return 0

    },
    
    mensalNaoAtendidasSaida(operador){
      let mensalNaoAtendidasSaida =''
      if(this.getCallsMonitorOperador.length != 0){
        if(this.getCallsMonitorOperador.Saida.length != 0){
          if(this.getCallsMonitorOperador.Saida.mensal.length != 0){

            this.getCallsMonitorOperador.Saida.mensal.forEach(dadoDeSaidaMensal => {
              if (dadoDeSaidaMensal.operador === operador.agent) {
                  mensalNaoAtendidasSaida = dadoDeSaidaMensal.naoAtendidas
                }
              })
              if (mensalNaoAtendidasSaida == '') {
                  mensalNaoAtendidasSaida = 0
              }
            return mensalNaoAtendidasSaida
          }else{
            return 0
          }
        }else{
          return 0
        }
      }
      return 0
    },
    
    mensalTotalEntrada(operador){
      let mensalTotalEntrada =''
      if(this.getCallsMonitorOperador.length != 0){
        if(this.getCallsMonitorOperador.Entrada.length != 0){
          if(this.getCallsMonitorOperador.Entrada.mensal.length != 0){

            this.getCallsMonitorOperador.Entrada.mensal.forEach(dadoDeEntradaMensal => {
              if (dadoDeEntradaMensal.operador === operador.agent) {
                mensalTotalEntrada = dadoDeEntradaMensal.totalChamadas
              } 
            })
            if (mensalTotalEntrada == '') {
                mensalTotalEntrada = 0
            }
            return mensalTotalEntrada
          }else{
            return 0
          }
        }else{
          return 0
        }
      }
      return 0
    },

    mensalTotalSaida(operador){
      let mensalTotalSaida =''
      if(this.getCallsMonitorOperador.length != 0){
        if(this.getCallsMonitorOperador.Saida.length != 0){
          if(this.getCallsMonitorOperador.Saida.mensal.length != 0){

            this.getCallsMonitorOperador.Saida.mensal.forEach(dadoDeSaidaMensal => {
              if (dadoDeSaidaMensal.operador === operador.agent) {
                mensalTotalSaida = dadoDeSaidaMensal.totalChamadas
              } 
            })
            if (mensalTotalSaida == '') {
                mensalTotalSaida = 0
            }
            return mensalTotalSaida
          }else{
            return 0
          }
        }else{
          return 0
        }
      }
      return 0
    },
    
    mensalTmc(operador){
      let mensalTmc = ''
      if(this.getCallsMonitorOperador.length != 0){
        if(this.getCallsMonitorOperador.Entrada.length != 0){
          if(this.getCallsMonitorOperador.Entrada.mensal.length != 0){

            this.getCallsMonitorOperador.Entrada.mensal.forEach(dadoDeEntradaMensal => {
              if (dadoDeEntradaMensal.operador === operador.agent) {
                mensalTmc = dadoDeEntradaMensal.mediaTempoDeChamada
              }
            })
            if (mensalTmc == '') {
                mensalTmc = '00:00:00'
            }
            return mensalTmc
          }else{
            return '00:00:00'
          }
        }else{
          return '00:00:00'
        }
      }
      return '00:00:00'
    },

    mensalTma(operador){
      let mensalTma = ''
      if(this.getCallsMonitorOperador.length != 0){
        if(this.getCallsMonitorOperador.Entrada.length != 0){
          if(this.getCallsMonitorOperador.Entrada.mensal.length != 0){

            this.getCallsMonitorOperador.Entrada.mensal.forEach(dadoDeEntradaMensal => {
              if (dadoDeEntradaMensal.operador === operador.agent) {
                mensalTma = dadoDeEntradaMensal.mediaTempoDeAtendimento
              } 
            })
            if (mensalTma == '') {
                mensalTma = '00:00:00'
            }
            return mensalTma
          }else{
            return '00:00:00'
          }
        }else{
          return '00:00:00'
        }
      }
      return '00:00:00'
    },

    mensalTme(operador){
      let mensalTme = ''
      if(this.getCallsMonitorOperador.length != 0){
        if(this.getCallsMonitorOperador.Entrada.length != 0){
          if(this.getCallsMonitorOperador.Entrada.mensal.length != 0){

            this.getCallsMonitorOperador.Entrada.mensal.forEach(dadoDeEntradaMensal => {
              if (dadoDeEntradaMensal.operador === operador.agent) {
                mensalTme = dadoDeEntradaMensal.mediaEspera
              }
            })
            if (mensalTme == '') {
                mensalTme = '00:00:00'
            }
            return mensalTme
          }else{
            return '00:00:00'
          }
        }else{
          return '00:00:00'
        }
      }
      return '00:00:00'
    },
}
